import {
  Paragraph, TextRun, Table, TableRow, TableCell,
  WidthType, BorderStyle, ShadingType, AlignmentType,
} from 'docx';
import { buildAverageRow, applyDifferenceToRows } from '../../utils/energiaUtils';

const NONE = { style: BorderStyle.NONE, size: 0, color: 'FFFFFF' };
const NO_BORDERS = { top: NONE, bottom: NONE, left: NONE, right: NONE };
const TABLE_NO_BORDERS = { ...NO_BORDERS, insideH: NONE, insideV: NONE };
const THIN_H = { style: BorderStyle.SINGLE, size: 2, color: 'cccccc' };

const GREEN = '04aa00';
const WHITE = 'FFFFFF';

function headerCell(text, widthPct) {
  return new TableCell({
    children: [new Paragraph({
      children: [new TextRun({ text: String(text), bold: true, color: WHITE, size: 18 })],
      alignment: AlignmentType.CENTER,
    })],
    shading: { fill: GREEN, type: ShadingType.SOLID },
    width: { size: widthPct, type: WidthType.PERCENTAGE },
    borders: { top: NONE, bottom: THIN_H, left: NONE, right: NONE },
  });
}

function bodyCell(text, isAverage, isFirst) {
  return new TableCell({
    children: [new Paragraph({
      children: [new TextRun({ text: String(text ?? ''), bold: isAverage, color: isAverage ? WHITE : '000000', size: 18 })],
      alignment: isFirst ? AlignmentType.LEFT : AlignmentType.CENTER,
    })],
    shading: isAverage ? { fill: GREEN, type: ShadingType.SOLID } : { fill: 'auto', type: ShadingType.CLEAR },
    borders: { top: NONE, bottom: THIN_H, left: NONE, right: NONE },
  });
}

export function renderEnergiaTableBlockDocx({ data, children }) {
  if (!data?.columns || !data?.rows) return;

  const { columns, rows, title } = data;
  const colCount = columns.length;

  const processedRows = applyDifferenceToRows(rows, columns);
  const averageRow = buildAverageRow(columns, processedRows);
  const allRows = averageRow ? [...processedRows, averageRow] : processedRows;

  // Column widths: first col 20%, rest split equally
  const firstPct = 20;
  const restPct = Math.floor((100 - firstPct) / Math.max(1, colCount - 1));

  const tableRows = [];

  // Title row (merged)
  tableRows.push(new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph({
          children: [new TextRun({ text: title || '', bold: true, color: WHITE, size: 22 })],
          alignment: AlignmentType.CENTER,
        })],
        columnSpan: colCount,
        shading: { fill: GREEN, type: ShadingType.SOLID },
        borders: NO_BORDERS,
      }),
    ],
  }));

  // Header row
  tableRows.push(new TableRow({
    children: columns.map((col, i) => headerCell(col, i === 0 ? firstPct : restPct)),
  }));

  // Body rows
  allRows.forEach(row => {
    const isAverage = row[columns[0]] === 'Keskiarvo';
    tableRows.push(new TableRow({
      children: columns.map((col, i) => bodyCell(row[col] ?? '', isAverage, i === 0)),
    }));
  });

  children.push(
    new Table({
      rows: tableRows,
      width: { size: 100, type: WidthType.PERCENTAGE },
      borders: TABLE_NO_BORDERS,
    })
  );
  children.push(new Paragraph({ children: [new TextRun('')], spacing: { after: 160 } }));
}
